export default __webpack_public_path__ + "static/media/login_image.573ca9bc.png";